module.exports = __webpack_public_path__ + "img/icons_Prancheta 1-83.112b2f7f.svg";